import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

import placeholder from "../_placeholders/-assets/placeholder-rule-and-policy.png";

export const Route = createFileRoute("/_staff/licenses/_list/rule-and-policy/")(
  {
    component: () => <ComingSoonCover placeholderImage={placeholder} />,
  },
);
